<div class="confirmation-modal">
  <div class="modal-header">
    <mat-icon 
      [ngClass]="{ 'warning-icon': isRemoveAction, 'success-icon': !isRemoveAction }"
      class="modal-icon">
      {{ iconName }}
    </mat-icon>
    <h2 mat-dialog-title class="modal-title">{{ modalTitle }}</h2>
  </div>

  <div mat-dialog-content class="modal-content">
    <p class="modal-message">{{ modalMessage }}</p>
    
    <div class="patient-details" *ngIf="isRemoveAction && data.patient.validatedDate">
      <p class="validation-info">
        <strong>Current validation:</strong><br>
        Validated by {{ data.patient.validationUserName || 'Unknown User' }}<br>
        on {{ formatValidationDate(data.patient.validatedDate) }}
      </p>
    </div>
  </div>

  <div mat-dialog-actions class="modal-actions">
    <button 
      mat-button 
      (click)="onCancel()"
      class="cancel-button">
      Cancel
    </button>
    <button 
      mat-raised-button 
      [color]="confirmButtonColor"
      (click)="onConfirm()"
      class="confirm-button">
      {{ confirmButtonText }}
    </button>
  </div>
</div>